import { render } from "./QuestVictory2.vue?vue&type=template&id=372c54ec"
import script from "./QuestVictory2.vue?vue&type=script&lang=js"
export * from "./QuestVictory2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/questVictories/QuestVictory2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "372c54ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('372c54ec', __exports__)) {
    api.reload('372c54ec', __exports__)
  }
  
  module.hot.accept("./QuestVictory2.vue?vue&type=template&id=372c54ec", () => {
    api.rerender('372c54ec', render)
  })

}


export default __exports__